export default __webpack_public_path__ + "static/media/back.81e0b281.svg";